import { Box, Card, Flex, HStack, Image, Spacer, Text } from "@chakra-ui/react";
import { ReactElement } from "react";

type Props = {
  title: string;
  description?: string;
  ctas: ReactElement[];
  icon: string;
};
export const AppDescriptionCard = ({ title, description, ctas, icon }: Props) => {
  return (
    <Card.Root borderRadius="3xl" position="relative" filter="auto" w="full">
      <Card.Body px={4}>
        <Flex flexDir={["column", "column", "row"]} alignItems={["flex-start", "flex-start", "center"]} gap={[4, 4, 0]}>
          <Image src={icon} mr={4} boxSize={8} />
          <Box>
            <Text mb={2} fontWeight="500" fontSize="lg" fontFamily="heading">
              {title}
            </Text>
            <Text
              fontSize="md"
              mr={4}
              fontWeight="500"
              color="fg.muted"
              lineHeight="24px"
              letterSpacing="-0.18px"
              whiteSpace="pre-line"
            >
              {description}
            </Text>
          </Box>
          <Spacer flex={1} />
          <HStack>{ctas}</HStack>
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
